module.exports = __webpack_public_path__ + "img/screenshotSlotGame.c2e4b3e2.jpg";